<template>
  <div>
    <Overlay
      data-testid="editPrescriptionOverlay"
      :open="openOverlay"
      :show-title="false"
      portal-target="#edit-prescription-portal"
      layout="right"
      enter-from="right"
      no-padding
      @update:open="closeOverlay"
    >
      <TopNavigation
        class="sticky top-0 z-[100] rounded-t-xl border-b border-shade-300 bg-white md:rounded-none"
        @click:close="closeOverlay"
      >
        {{ $t('rxConfigurator.step.prescriptionValues') }}
      </TopNavigation>
      <div
        class="flex w-full flex-col gap-y-4 px-8 py-4"
        data-testid="rx-step-prescription-values"
      >
        <form class="space-y-8 py-4" @submit.prevent>
          <RxSightPrescriptionValue
            v-for="currentStep in prescriptionSteps"
            :key="currentStep.name"
            :name="currentStep.name"
            :unit="currentStep.unit"
            :validate="currentStep.validate"
            :options="currentStep.options"
            :min="currentStep.min"
            :max="currentStep.max"
            :is-optional="currentStep.isOptional"
            :step="currentStep.step"
            :storyblok-slug="currentStep.storyblokSlug"
          />

          <FimButton
            class="w-full"
            :disabled="!hasValidPrescriptionValues"
            @click="addToBasket"
          >
            {{ $t('rx.prescription.summary.btnConfirmText') }}
          </FimButton>
        </form>
      </div>
    </Overlay>
  </div>
</template>

<script setup lang="ts">
import getPrescriptionSteps from '~/composables/rxConfig/PrescriptionFormConfig'
import useUiState from '~/composables/ui/useUiState'

const { resetPrescriptionValues, hasValidPrescriptionValues } =
  useRxPrescription()
const { fetchFittingHeight } = await useRxConfiguratorState()

const emit = defineEmits(['addToBasket'])

const {
  closeRxEditPrescriptionOverlay: closeOverlay,
  isRxEditPrescriptionOverlayOpen: openOverlay,
  rxEditPrescriptionOverlayId,
} = useUiState()
const $currentShop = useCurrentShop()

const addToBasket = () => {
  // trigger fetch fitting height to get hdp value (required).
  // useRxConfiguratorState.serialize will await the result
  fetchFittingHeight()
  emit('addToBasket', { itemGroupId: rxEditPrescriptionOverlayId.value })
  closeOverlay()
}

const prescriptionSteps = computed(() =>
  getPrescriptionSteps($currentShop.value),
)
</script>
